// ======================================================================
// FILE:
// src/modules/service_crm/installed_products/components/InstalledProductKpiBar.js
//
// MODULE: Service CRM
// FEATURE: Installed Product KPI Bar
// ======================================================================

import React from "react";

export default function InstalledProductKpiBar({
  rows = [],
}) {

  // -------------------------------------------------------------------
  // KPI CALCULATIONS
  // -------------------------------------------------------------------

  const totalProducts = rows.length;

  const commissionedProducts =
    rows.filter(
      (r) =>
        (
          r.commissioning_status || ""
        ).toLowerCase() === "commissioned"
    ).length;

  const pendingProducts =
    rows.filter(
      (r) =>
        (
          r.commissioning_status || ""
        ).toLowerCase() !== "commissioned"
    ).length;

  const inactiveProducts =
    rows.filter(
      (r) =>
        (r.is_active === false)
    ).length;

  // -------------------------------------------------------------------
  // KPI CARD
  // -------------------------------------------------------------------
  const Card = ({
    title,
    value,
    icon,
    color,
  }) => (

    <div
      style={{
        flex: 1,

        minWidth: 180,

        background: "#fff",

        borderRadius: 14,

        padding: 18,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

        borderTop:
          `4px solid ${color}`,
      }}
    >

      <div
        style={{
          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",
        }}
      >

        {/* LEFT */}
        <div>

          <div
            style={{
              fontSize: 13,

              color: "#6c757d",

              marginBottom: 6,
            }}
          >
            {title}
          </div>

          <div
            style={{
              fontSize: 24,

              fontWeight: 700,

              color: "#212529",
            }}
          >
            {value}
          </div>

        </div>

        {/* RIGHT */}
        <div
          style={{
            fontSize: 30,
          }}
        >
          {icon}
        </div>

      </div>

    </div>
  );

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div
      style={{
        display: "flex",

        gap: 16,

        flexWrap: "wrap",

        marginBottom: 20,
      }}
    >

      {/* TOTAL */}
      <Card
        title="Total Products"
        value={totalProducts}
        icon="📦"
        color="#0d6efd"
      />

      {/* COMMISSIONED */}
      <Card
        title="Commissioned"
        value={commissionedProducts}
        icon="✅"
        color="#198754"
      />

      {/* PENDING */}
      <Card
        title="Pending"
        value={pendingProducts}
        icon="⏳"
        color="#fd7e14"
      />

      {/* INACTIVE */}
      <Card
        title="Inactive"
        value={inactiveProducts}
        icon="🚫"
        color="#dc3545"
      />

    </div>
  );
}